/*
Based on: 
Details Element Polyfill 2.1.1
Copyright © 2018 Javan Makhmali
 */

var element = document.createElement('details');
element.innerHTML = '<summary>a</summary>b';
element.setAttribute('style', 'position: absolute; left: -9999px');
var support = {
    open: 'open' in element && elementExpands(),
    toggle: 'ontoggle' in element
};

function elementExpands() {
    (document.body || document.documentElement).appendChild(element);
    var closedHeight = element.offsetHeight;
    element.open = true;
    var openedHeight = element.offsetHeight;
    element.parentNode.removeChild(element);
    return closedHeight != openedHeight;
}

var _ref = [], forEach = _ref.forEach, slice = _ref.slice;
if (!support.open) {
    polyfillProperties();
    polyfillToggle();
    polyfillAccessibility();
}
if (support.open && !support.toggle) {
    polyfillToggleEvent();
}

function polyfillProperties() {
    var prototype = document.createElement('details').constructor.prototype;
    var setAttribute = prototype.setAttribute, removeAttribute = prototype.removeAttribute;
    var open = Object.getOwnPropertyDescriptor(prototype, 'open');
    Object.defineProperties(prototype,
        {
            open: {
                get: function get() {
                    if (this.tagName == 'DETAILS') {
                        return this.hasAttribute('open');
                    } else {
                        if (open && open.get) {
                            return open.get.call(this);
                        }
                    }
                },
                set: function set(value) {
                    if (this.tagName == 'DETAILS') {
                        return value ? this.setAttribute('open', '') : this.removeAttribute('open');
                    } else {
                        if (open && open.set) {
                            return open.set.call(this, value);
                        }
                    }
                }
            },
            setAttribute: {
                value: function value(name, _value) {
                    var _this = this;
                    var call = function call() {
                        setAttribute.call(_this, name, _value);
                    };
                    return this.tagName == 'DETAILS' ? triggerToggleIfToggled(this, call) : call();
                }
            },
            removeAttribute: {
                value: function value(name) {
                    var _this2 = this;
                    var call = function call() {
                        removeAttribute.call(_this2, name);
                    };
                    return this.tagName == 'DETAILS' ? triggerToggleIfToggled(this, call) : call();
                }
            }
        });
}

function polyfillToggle() {
    onTogglingTrigger(function (element) {
        var summary = element.querySelector('summary');
        if (element.hasAttribute('open')) {
            element.removeAttribute('open');
            summary.setAttribute('aria-expanded', false);
        } else {
            element.setAttribute('open', '');
            summary.setAttribute('aria-expanded', true);
        }
    });
}

function polyfillToggleEvent() {
    if (window.MutationObserver) {
        new MutationObserver(function (mutations) {
            forEach.call(mutations,
                function (mutation) {
                    var target = mutation.target, attributeName = mutation.attributeName;
                    if (target.tagName == 'DETAILS' && attributeName == 'open') {
                        triggerToggle(target);
                    }
                });
        }).observe(document.documentElement,
            {
                attributes: true,
                subtree: true
            });
    } else {
        onTogglingTrigger(function (element) {
            var wasOpen = element.getAttribute('open');
            setTimeout(function () {
                var isOpen = element.getAttribute('open');
                if (wasOpen != isOpen) {
                    triggerToggle(element);
                }
            }, 1);
        });
    }
}

function polyfillAccessibility() {
    setAccessibilityAttributes(document);
    if (window.MutationObserver) {
        new MutationObserver(function (mutations) {
            forEach.call(mutations,
                function (mutation) {
                    forEach.call(mutation.addedNodes, setAccessibilityAttributes);
                });
        }).observe(document.documentElement,
            {
                subtree: true,
                childList: true
            });
    } else {
        document.addEventListener('DOMNodeInserted',
            function (event) {
                setAccessibilityAttributes(event.target);
            });
    }
}

function setAccessibilityAttributes(root) {
    findElementsWithTagName(root, 'SUMMARY').forEach(function (summary) {
        var details = findClosestElementWithTagName(summary, 'DETAILS');
        summary.setAttribute('aria-expanded', details.hasAttribute('open'));
        if (!summary.hasAttribute('tabindex')) summary.setAttribute('tabindex', '0');
        if (!summary.hasAttribute('role')) summary.setAttribute('role', 'button');
    });
}

function eventIsSignificant(event) {
    return !(event.defaultPrevented ||
        event.ctrlKey ||
        event.metaKey ||
        event.shiftKey ||
        event.target.isContentEditable);
}

function onTogglingTrigger(callback) {
    addEventListener('click',
        function (event) {
            if (eventIsSignificant(event)) {
                if (event.which <= 1) {
                    var element = findClosestElementWithTagName(event.target, 'SUMMARY');
                    if (element && element.parentNode && element.parentNode.tagName == 'DETAILS') {
                        callback(element.parentNode);
                    }
                }
            }
        },
        false);
    addEventListener('keydown',
        function (event) {
            if (eventIsSignificant(event)) {
                if (event.keyCode == 13 || event.keyCode == 32) {
                    var element = findClosestElementWithTagName(event.target, 'SUMMARY');
                    if (element && element.parentNode && element.parentNode.tagName == 'DETAILS') {
                        callback(element.parentNode);
                        event.preventDefault();
                    }
                }
            }
        },
        false);
}

function triggerToggle(element) {
    var toggleEvent;
    try {
        toggleEvent = new CustomEvent('toggle', { bubbles: true, cancelable: true });
    } catch (error) {
        toggleEvent = document.createEvent('CustomEvent');
        toggleEvent.initCustomEvent('toggle', true, true, null);
    }
    element.dispatchEvent(toggleEvent);
}

function triggerToggleIfToggled(element, callback) {
    var wasOpen = element.getAttribute('open');
    var result = callback();
    var isOpen = element.getAttribute('open');
    if (wasOpen != isOpen) {
        triggerToggle(element);
    }
    return result;
}

function findElementsWithTagName(root, tagName) {
    return (root.tagName == tagName ? [root] : []).concat(typeof root.getElementsByTagName == 'function'
        ? slice.call(root.getElementsByTagName(tagName))
        : []);
}

function findClosestElementWithTagName(element, tagName) {
    if (typeof element.closest == 'function') {
        return element.closest(tagName);
    } else {
        while (element) {
            if (element.tagName == tagName) {
                return element;
            } else {
                element = element.parentNode;
            }
        }
    }
}